const SETTLE_MS = 300;

export const deferHoverPrefetch = () => {
  const loader = typeof window !== 'undefined' && window.___loader;
  if (!loader || typeof loader.hovering !== 'function' || loader.__nbDeferredHover) return;

  const hovering = loader.hovering;
  let timer = 0;
  let idle = 0;

  loader.hovering = rawPath => {
    window.clearTimeout(timer);
    if (idle && typeof window.cancelIdleCallback === 'function') window.cancelIdleCallback(idle);
    idle = 0;

    timer = window.setTimeout(() => {
      if (typeof window.requestIdleCallback === 'function') {
        idle = window.requestIdleCallback(() => hovering(rawPath), { timeout: 1000 });
      } else {
        hovering(rawPath);
      }
    }, SETTLE_MS);
  };
  loader.__nbDeferredHover = true;
};
